<div class="group-container" fxLayout="row">
  <div fxFlex>

    <div fxLayout="row-reverse" *ngIf="groupSize !== undefined" class="group-sections">
      <div *ngIf="groupSize !== 0" [fxFlex]="(100 / max) * groupSize" class="group-buttons">

        <button type="button" mat-icon-button [disabled]="groupSize >= max" (click)="addGroup()">
          <mat-icon>arrow_left</mat-icon>
        </button>

        <span class="group-sub">
          {{groupName}}
        </span>

        <button type="button" mat-icon-button [disabled]="groupSize <= max - sectionsLength + 1"
          (click)="removeGroup()">
          <mat-icon>arrow_right</mat-icon>
        </button>

      </div>
    </div>

    <div class="group-content">
      <ng-content></ng-content>
    </div>

  </div>
</div>
